// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.lotus-casino-shell {
  width: 100%;
  min-height: 100%;
  background: #080808;
  color: #ffffff;
  position: relative;
}

.lotus-casino-launch-root {
  position: relative;
  width: 100%;
}

.lotus-casino-shell__layout-content {
  width: 100%;
  max-width: 100%;
  padding: 0;
  box-sizing: border-box;
}

.lotus-casino-shell__banner {
  width: 100%;
  height: 150px;
  overflow: hidden;
  margin-bottom: 8px;
}

.lotus-casino-shell__banner .promo-banner-section {
  height: 150px;
  margin: 0;
}

.lotus-casino-shell__banner .promo-carousel-viewport {
  height: 150px;
}

.lotus-casino-shell__banner .promo-slide {
  height: 150px;
}

.lotus-casino-shell__banner .promo-slide img {
  width: 100%;
  height: 150px;
  object-fit: cover;
  border-radius: 0;
}

.lotus-casino-shell__games {
  width: 100%;
}

.lotus-casino-shell__games.is-hidden {
  display: none;
}

.lotus-casino-play-bridge {
  position: absolute;
  width: 1px;
  height: 1px;
  overflow: hidden;
  opacity: 0;
  pointer-events: none;
  clip: rect(0, 0, 0, 0);
}

/* Invisible launch host — keeps iframe fullscreen while hiding legacy casino chrome */
.lotus-casino-launch-bridge {
  position: absolute;
  inset: 0;
  width: 0;
  height: 0;
  overflow: visible;
  pointer-events: none;
  z-index: 0;
}

.lotus-casino-launch-bridge .casino-page-wrap {
  background: transparent;
}

.lotus-casino-launch-bridge .casino-page-wrap > .w-100 {
  display: none !important;
}

.lotus-casino-launch-bridge .casino-page-wrap > .slot-iframe.show {
  pointer-events: auto;
}

.lotus-casino-shell.is-provider-mode .lotus-casino-shell__games {
  display: none !important;
}

/* Hide legacy casino chrome when Lotus shell is active */
.lotus-casino-mode .casino-page-wrap > .w-100 > .casino-banner,
.lotus-casino-mode .casino-page-wrap > .w-100 > .game-providers-section,
.lotus-casino-mode .casino-page-wrap > .w-100 > .w-100:has(.casino-nav),
.lotus-casino-shell.is-tab-mode .lotus-casino-shell__games,
.lotus-casino-shell.is-lobby-mode .lotus-casino-shell__games {
  display: none !important;
}

.lotus-casino-mode .casino-page-wrap {
  background: transparent;
}

.lotus-casino-mode .casino-page-wrap > .w-100 {
  background: transparent;
}

.lotus-casino-mode .casino-page-wrap .nav-search-main {
  margin-top: 8px;
  margin-bottom: 12px;
}

.lotus-casino-mode .casino-page-wrap .nav-search-input {
  background: #171717;
  border: 1px solid rgba(255, 255, 255, 0.12);
  color: #ffffff;
}

.lotus-casino-mode .casino-page-wrap .nav-search-input::placeholder {
  color: rgba(255, 255, 255, 0.45);
}

.lotus-casino-mode .casino-page-wrap .casino-list {
  display: flex;
  flex-wrap: wrap;
  gap: 12px 16px;
}

.lotus-casino-mode .casino-page-wrap .casino-list-item {
  width: 183.2px;
  margin: 0;
}

.lotus-casino-mode .casino-page-wrap h5 {
  color: #ffffff !important;
}

.lotus-casino-mode .casino-page-wrap .casino-list-item-banner {
  height: 115px;
  border-radius: 8px;
}

/* Casino layout: sidebar dark + main dark bg */
.pre-dashboard.is-casino-theme .desktop-left-sidebar.is-casino-sidebar,
.dashboard-container.is-casino-theme .desktop-left-sidebar.is-casino-sidebar {
  background: #171717;
  border-radius: 8px 8px 0 0;
}

.pre-dashboard.is-casino-theme .desktop-layout-wrapper.casino-layout,
.dashboard-container.is-casino-theme .desktop-layout-wrapper.casino-layout {
  background: #080808;
  gap: 12px;
  padding-left: 12px !important;
  padding-right: 12px !important;
}

.pre-dashboard.is-casino-theme .desktop-main-content.lotus-casino-main,
.dashboard-container.is-casino-theme .desktop-main-content.lotus-casino-main {
  background: #080808;
  border-radius: 8px 8px 0 0;
}

.pre-dashboard.is-casino-theme .desktop-main-content.lotus-casino-main > .lotus-regulatory-footer,
.pre-dashboard.is-casino-theme .desktop-main-content.lotus-casino-main > footer,
.dashboard-container.is-casino-theme .desktop-main-content.lotus-casino-main > .lotus-regulatory-footer,
.dashboard-container.is-casino-theme .desktop-main-content.lotus-casino-main > footer {
  background: #080808;
}

/* Header casino theme */
.pre-dashboard.is-casino-theme .lotus-header,
.pre-dashboard.is-casino-theme .dashboard-lotus-header,
.dashboard-container.is-casino-theme .lotus-header,
.dashboard-container.is-casino-theme .dashboard-lotus-header {
  background: #080808 !important;
}

.pre-dashboard.is-casino-theme .lotus-header-nav-tab.selected,
.pre-dashboard.is-casino-theme .lotus-header-nav-tab.selected .lotus-header-nav-label,
.dashboard-container.is-casino-theme .lotus-header-nav-tab.selected,
.dashboard-container.is-casino-theme .lotus-header-nav-tab.selected .lotus-header-nav-label {
  color: #67af7e !important;
}

.pre-dashboard.is-casino-theme .lotus-header-nav-tab.selected::after,
.dashboard-container.is-casino-theme .lotus-header-nav-tab.selected::after {
  background: #67af7e !important;
}

.pre-dashboard.is-casino-theme .lotus-header-pill:not(.lotus-wallet-pill):not(.lotus-profile-pill),
.dashboard-container.is-casino-theme .lotus-header-pill:not(.lotus-wallet-pill):not(.lotus-profile-pill) {
  background: rgba(103, 175, 126, 0.15);
  border-color: rgba(103, 175, 126, 0.35);
  color: #67af7e;
}

.pre-dashboard.is-casino-theme .dashboard-lotus-header-stack,
.dashboard-container.is-casino-theme .dashboard-lotus-header-stack {
  background: #080808;
}

/* Casino header: white utility text + Lotus pill colors */
.pre-dashboard.is-casino-theme .lotus-header-right,
.pre-dashboard.is-casino-theme .lotus-header-clock,
.pre-dashboard.is-casino-theme .lotus-header-clock-text,
.pre-dashboard.is-casino-theme .lotus-header-timezone-btn,
.pre-dashboard.is-casino-theme .lotus-header-icon-btn,
.dashboard-container.is-casino-theme .lotus-header-right,
.dashboard-container.is-casino-theme .lotus-header-clock,
.dashboard-container.is-casino-theme .lotus-header-clock-text,
.dashboard-container.is-casino-theme .lotus-header-timezone-btn,
.dashboard-container.is-casino-theme .lotus-header-icon-btn {
  color: #ffffff !important;
}

.pre-dashboard.is-casino-theme .lotus-wallet-pill,
.dashboard-container.is-casino-theme .lotus-wallet-pill {
  background: rgba(255, 255, 255, 0.1) !important;
  color: #ffffff !important;
  height: 40px;
  padding: 10px 12px;
  border-radius: 8px;
  margin-right: 8px;
}

.pre-dashboard.is-casino-theme .lotus-wallet-pill:hover,
.pre-dashboard.is-casino-theme .lotus-wallet-pill.active,
.dashboard-container.is-casino-theme .lotus-wallet-pill:hover,
.dashboard-container.is-casino-theme .lotus-wallet-pill.active {
  background: #2a2a2a !important;
}

.pre-dashboard.is-casino-theme .lotus-profile-pill,
.dashboard-container.is-casino-theme .lotus-profile-pill {
  background: #2c4f58 !important;
  color: #ffffff !important;
  height: 40px;
  padding: 0 12px;
  border-radius: 6px;
}

.pre-dashboard.is-casino-theme .lotus-profile-pill:hover,
.pre-dashboard.is-casino-theme .lotus-profile-pill.active,
.dashboard-container.is-casino-theme .lotus-profile-pill:hover,
.dashboard-container.is-casino-theme .lotus-profile-pill.active {
  background: #356069 !important;
}

.pre-dashboard.is-casino-theme .lotus-wallet-pill .icon,
.pre-dashboard.is-casino-theme .lotus-profile-pill .icon,
.dashboard-container.is-casino-theme .lotus-wallet-pill .icon,
.dashboard-container.is-casino-theme .lotus-profile-pill .icon {
  color: #ffffff !important;
}

/* Alias dashboard header to lotus header base styles */
.dashboard-lotus-header-stack {
  position: fixed !important;
  top: 0;
  left: 0;
  right: 0;
  z-index: 1000;
  width: 100%;
}

.dashboard-lotus-header {
  background: #0f2327;
  width: 100%;
  height: 60px;
  position: relative !important;
  top: auto;
  left: auto;
  right: auto;
  z-index: auto;
  font-family: "Lato", sans-serif !important;
}

@media (max-width: 768px) {
  .dashboard-lotus-header {
    position: relative !important;
    height: 60px;
  }
}

.dashboard-lotus-header-container {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  position: relative;
}

@media (max-width: 768px) {
  .dashboard-lotus-header-container {
    padding-right: 8px;
    box-sizing: border-box;
    overflow: visible;
    min-width: 0;
  }

  .dashboard-lotus-mobile-hamburger {
    display: flex;
    align-items: center;
    justify-content: center;
    background: transparent;
    border: none;
    color: #fff;
    cursor: pointer;
    padding: 0;
    margin-left: 15px;
    width: 18px;
    min-width: 18px;
    height: 36px;
    flex-shrink: 0;
  }

  .dashboard-lotus-mobile-hamburger.is-back {
    width: 25px;
    min-width: 25px;
  }

  .dashboard-lotus-mobile-hamburger .icon-burger {
    font-size: 12px;
    color: #fff;
    line-height: 1;
  }

  .dashboard-lotus-mobile-hamburger .icon-angle-left {
    font-size: 14px;
    color: #fff;
    line-height: 1;
  }

  .dashboard-lotus-header-left {
    display: flex;
    align-items: center;
    height: 36px;
    flex-shrink: 1;
    min-width: 0;
  }

  .dashboard-lotus-logo {
    height: 29px;
    width: 120px;
    max-width: 120px;
    margin-left: 12px;
    object-fit: contain;
    flex-shrink: 1;
  }
}

@media (max-width: 1023px) {
  .lotus-casino-shell__banner {
    height: auto;
    min-height: 120px;
  }
}

/* Mobile casino banners — Lotus 312×115 cover */
@media (max-width: 1119px) {
  .lotus-casino-shell__banner {
    height: 115px;
    min-height: 115px;
    margin-bottom: 0;
    overflow: hidden;
  }

  .lotus-casino-shell__banner .promo-banner-section {
    height: 115px;
    margin: 0;
  }

  .lotus-casino-shell__banner .promo-carousel-viewport {
    height: 115px;
  }

  .lotus-casino-shell__banner .promo-slide {
    height: 115px;
    width: 312px;
    max-width: calc(100% - 40px);
    border-radius: 8px;
    overflow: hidden;
  }

  .lotus-casino-shell__banner .promo-slide img {
    width: 100%;
    height: 115px;
    object-fit: cover;
    border-radius: 8px;
  }

  /*
   * Casino mobile: document scroll so regulatory footer below content is reachable.
   * (flex:1 + overflow-x:clip on layout wrapper otherwise traps scroll without footer)
   */
  .pre-dashboard.is-casino-theme,
  .dashboard-container.is-casino-theme {
    height: auto !important;
    max-height: none !important;
    overflow: visible !important;
  }

  .pre-dashboard.is-casino-theme .desktop-layout-wrapper.casino-layout,
  .dashboard-container.is-casino-theme .desktop-layout-wrapper.casino-layout {
    flex: none !important;
    min-height: auto !important;
    height: auto !important;
    max-height: none !important;
    overflow: visible !important;
    overflow-x: visible !important;
    overflow-y: visible !important;
  }

  .pre-dashboard.is-casino-theme .desktop-main-content.lotus-casino-main,
  .dashboard-container.is-casino-theme .desktop-main-content.lotus-casino-main {
    height: auto !important;
    max-height: none !important;
    min-height: auto !important;
    overflow: visible !important;
    overflow-x: visible !important;
    overflow-y: visible !important;
  }

  .pre-dashboard.is-casino-theme > .lotus-regulatory-footer,
  .dashboard-container.is-casino-theme > .lotus-regulatory-footer {
    display: block !important;
    background: #080808;
    padding-bottom: 72px;
    box-sizing: border-box;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/LotusCasinoShell/LotusCasinoShell.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,eAAe;EACf,UAAU;EACV,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,WAAW;EACX,aAAa;EACb,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,gBAAgB;EAChB,UAAU;EACV,oBAAoB;EACpB,sBAAsB;AACxB;;AAEA,sFAAsF;AACtF;EACE,kBAAkB;EAClB,QAAQ;EACR,QAAQ;EACR,SAAS;EACT,iBAAiB;EACjB,oBAAoB;EACpB,UAAU;AACZ;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA,yDAAyD;AACzD;;;;;EAKE,wBAAwB;AAC1B;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,2CAA2C;EAC3C,cAAc;AAChB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,SAAS;AACX;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,kBAAkB;AACpB;;AAEA,+CAA+C;AAC/C;;EAEE,mBAAmB;EACnB,0BAA0B;AAC5B;;AAEA;;EAEE,mBAAmB;EACnB,SAAS;EACT,6BAA6B;EAC7B,8BAA8B;AAChC;;AAEA;;EAEE,mBAAmB;EACnB,0BAA0B;AAC5B;;AAEA;;;;EAIE,mBAAmB;AACrB;;AAEA,wBAAwB;AACxB;;;;EAIE,8BAA8B;AAChC;;AAEA;;;;EAIE,yBAAyB;AAC3B;;AAEA;;EAEE,8BAA8B;AAChC;;AAEA;;EAEE,qCAAqC;EACrC,uCAAuC;EACvC,cAAc;AAChB;;AAEA;;EAEE,mBAAmB;AACrB;;AAEA,0DAA0D;AAC1D;;;;;;;;;;EAUE,yBAAyB;AAC3B;;AAEA;;EAEE,+CAA+C;EAC/C,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;;;;EAIE,8BAA8B;AAChC;;AAEA;;EAEE,8BAA8B;EAC9B,yBAAyB;EACzB,YAAY;EACZ,eAAe;EACf,kBAAkB;AACpB;;AAEA;;;;EAIE,8BAA8B;AAChC;;AAEA;;;;EAIE,yBAAyB;AAC3B;;AAEA,uDAAuD;AACvD;EACE,0BAA0B;EAC1B,MAAM;EACN,OAAO;EACP,QAAQ;EACR,aAAa;EACb,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,6BAA6B;EAC7B,SAAS;EACT,UAAU;EACV,WAAW;EACX,aAAa;EACb,0CAA0C;AAC5C;;AAEA;EACE;IACE,6BAA6B;IAC7B,YAAY;EACd;AACF;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,2BAA2B;EAC3B,kBAAkB;AACpB;;AAEA;EACE;IACE,kBAAkB;IAClB,sBAAsB;IACtB,iBAAiB;IACjB,YAAY;EACd;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,uBAAuB;IACvB,YAAY;IACZ,WAAW;IACX,eAAe;IACf,UAAU;IACV,iBAAiB;IACjB,WAAW;IACX,eAAe;IACf,YAAY;IACZ,cAAc;EAChB;;EAEA;IACE,WAAW;IACX,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,WAAW;IACX,cAAc;EAChB;;EAEA;IACE,eAAe;IACf,WAAW;IACX,cAAc;EAChB;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,YAAY;IACZ,cAAc;IACd,YAAY;EACd;;EAEA;IACE,YAAY;IACZ,YAAY;IACZ,gBAAgB;IAChB,iBAAiB;IACjB,mBAAmB;IACnB,cAAc;EAChB;AACF;;AAEA;EACE;IACE,YAAY;IACZ,iBAAiB;EACnB;AACF;;AAEA,gDAAgD;AAChD;EACE;IACE,aAAa;IACb,iBAAiB;IACjB,gBAAgB;IAChB,gBAAgB;EAClB;;EAEA;IACE,aAAa;IACb,SAAS;EACX;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;IACb,YAAY;IACZ,4BAA4B;IAC5B,kBAAkB;IAClB,gBAAgB;EAClB;;EAEA;IACE,WAAW;IACX,aAAa;IACb,iBAAiB;IACjB,kBAAkB;EACpB;;EAEA;;;IAGE;EACF;;IAEE,uBAAuB;IACvB,2BAA2B;IAC3B,4BAA4B;EAC9B;;EAEA;;IAEE,qBAAqB;IACrB,2BAA2B;IAC3B,uBAAuB;IACvB,2BAA2B;IAC3B,4BAA4B;IAC5B,8BAA8B;IAC9B,8BAA8B;EAChC;;EAEA;;IAEE,uBAAuB;IACvB,2BAA2B;IAC3B,2BAA2B;IAC3B,4BAA4B;IAC5B,8BAA8B;IAC9B,8BAA8B;EAChC;;EAEA;;IAEE,yBAAyB;IACzB,mBAAmB;IACnB,oBAAoB;IACpB,sBAAsB;EACxB;AACF","sourcesContent":[".lotus-casino-shell {\n  width: 100%;\n  min-height: 100%;\n  background: #080808;\n  color: #ffffff;\n  position: relative;\n}\n\n.lotus-casino-launch-root {\n  position: relative;\n  width: 100%;\n}\n\n.lotus-casino-shell__layout-content {\n  width: 100%;\n  max-width: 100%;\n  padding: 0;\n  box-sizing: border-box;\n}\n\n.lotus-casino-shell__banner {\n  width: 100%;\n  height: 150px;\n  overflow: hidden;\n  margin-bottom: 8px;\n}\n\n.lotus-casino-shell__banner .promo-banner-section {\n  height: 150px;\n  margin: 0;\n}\n\n.lotus-casino-shell__banner .promo-carousel-viewport {\n  height: 150px;\n}\n\n.lotus-casino-shell__banner .promo-slide {\n  height: 150px;\n}\n\n.lotus-casino-shell__banner .promo-slide img {\n  width: 100%;\n  height: 150px;\n  object-fit: cover;\n  border-radius: 0;\n}\n\n.lotus-casino-shell__games {\n  width: 100%;\n}\n\n.lotus-casino-shell__games.is-hidden {\n  display: none;\n}\n\n.lotus-casino-play-bridge {\n  position: absolute;\n  width: 1px;\n  height: 1px;\n  overflow: hidden;\n  opacity: 0;\n  pointer-events: none;\n  clip: rect(0, 0, 0, 0);\n}\n\n/* Invisible launch host — keeps iframe fullscreen while hiding legacy casino chrome */\n.lotus-casino-launch-bridge {\n  position: absolute;\n  inset: 0;\n  width: 0;\n  height: 0;\n  overflow: visible;\n  pointer-events: none;\n  z-index: 0;\n}\n\n.lotus-casino-launch-bridge .casino-page-wrap {\n  background: transparent;\n}\n\n.lotus-casino-launch-bridge .casino-page-wrap > .w-100 {\n  display: none !important;\n}\n\n.lotus-casino-launch-bridge .casino-page-wrap > .slot-iframe.show {\n  pointer-events: auto;\n}\n\n.lotus-casino-shell.is-provider-mode .lotus-casino-shell__games {\n  display: none !important;\n}\n\n/* Hide legacy casino chrome when Lotus shell is active */\n.lotus-casino-mode .casino-page-wrap > .w-100 > .casino-banner,\n.lotus-casino-mode .casino-page-wrap > .w-100 > .game-providers-section,\n.lotus-casino-mode .casino-page-wrap > .w-100 > .w-100:has(.casino-nav),\n.lotus-casino-shell.is-tab-mode .lotus-casino-shell__games,\n.lotus-casino-shell.is-lobby-mode .lotus-casino-shell__games {\n  display: none !important;\n}\n\n.lotus-casino-mode .casino-page-wrap {\n  background: transparent;\n}\n\n.lotus-casino-mode .casino-page-wrap > .w-100 {\n  background: transparent;\n}\n\n.lotus-casino-mode .casino-page-wrap .nav-search-main {\n  margin-top: 8px;\n  margin-bottom: 12px;\n}\n\n.lotus-casino-mode .casino-page-wrap .nav-search-input {\n  background: #171717;\n  border: 1px solid rgba(255, 255, 255, 0.12);\n  color: #ffffff;\n}\n\n.lotus-casino-mode .casino-page-wrap .nav-search-input::placeholder {\n  color: rgba(255, 255, 255, 0.45);\n}\n\n.lotus-casino-mode .casino-page-wrap .casino-list {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 12px 16px;\n}\n\n.lotus-casino-mode .casino-page-wrap .casino-list-item {\n  width: 183.2px;\n  margin: 0;\n}\n\n.lotus-casino-mode .casino-page-wrap h5 {\n  color: #ffffff !important;\n}\n\n.lotus-casino-mode .casino-page-wrap .casino-list-item-banner {\n  height: 115px;\n  border-radius: 8px;\n}\n\n/* Casino layout: sidebar dark + main dark bg */\n.pre-dashboard.is-casino-theme .desktop-left-sidebar.is-casino-sidebar,\n.dashboard-container.is-casino-theme .desktop-left-sidebar.is-casino-sidebar {\n  background: #171717;\n  border-radius: 8px 8px 0 0;\n}\n\n.pre-dashboard.is-casino-theme .desktop-layout-wrapper.casino-layout,\n.dashboard-container.is-casino-theme .desktop-layout-wrapper.casino-layout {\n  background: #080808;\n  gap: 12px;\n  padding-left: 12px !important;\n  padding-right: 12px !important;\n}\n\n.pre-dashboard.is-casino-theme .desktop-main-content.lotus-casino-main,\n.dashboard-container.is-casino-theme .desktop-main-content.lotus-casino-main {\n  background: #080808;\n  border-radius: 8px 8px 0 0;\n}\n\n.pre-dashboard.is-casino-theme .desktop-main-content.lotus-casino-main > .lotus-regulatory-footer,\n.pre-dashboard.is-casino-theme .desktop-main-content.lotus-casino-main > footer,\n.dashboard-container.is-casino-theme .desktop-main-content.lotus-casino-main > .lotus-regulatory-footer,\n.dashboard-container.is-casino-theme .desktop-main-content.lotus-casino-main > footer {\n  background: #080808;\n}\n\n/* Header casino theme */\n.pre-dashboard.is-casino-theme .lotus-header,\n.pre-dashboard.is-casino-theme .dashboard-lotus-header,\n.dashboard-container.is-casino-theme .lotus-header,\n.dashboard-container.is-casino-theme .dashboard-lotus-header {\n  background: #080808 !important;\n}\n\n.pre-dashboard.is-casino-theme .lotus-header-nav-tab.selected,\n.pre-dashboard.is-casino-theme .lotus-header-nav-tab.selected .lotus-header-nav-label,\n.dashboard-container.is-casino-theme .lotus-header-nav-tab.selected,\n.dashboard-container.is-casino-theme .lotus-header-nav-tab.selected .lotus-header-nav-label {\n  color: #67af7e !important;\n}\n\n.pre-dashboard.is-casino-theme .lotus-header-nav-tab.selected::after,\n.dashboard-container.is-casino-theme .lotus-header-nav-tab.selected::after {\n  background: #67af7e !important;\n}\n\n.pre-dashboard.is-casino-theme .lotus-header-pill:not(.lotus-wallet-pill):not(.lotus-profile-pill),\n.dashboard-container.is-casino-theme .lotus-header-pill:not(.lotus-wallet-pill):not(.lotus-profile-pill) {\n  background: rgba(103, 175, 126, 0.15);\n  border-color: rgba(103, 175, 126, 0.35);\n  color: #67af7e;\n}\n\n.pre-dashboard.is-casino-theme .dashboard-lotus-header-stack,\n.dashboard-container.is-casino-theme .dashboard-lotus-header-stack {\n  background: #080808;\n}\n\n/* Casino header: white utility text + Lotus pill colors */\n.pre-dashboard.is-casino-theme .lotus-header-right,\n.pre-dashboard.is-casino-theme .lotus-header-clock,\n.pre-dashboard.is-casino-theme .lotus-header-clock-text,\n.pre-dashboard.is-casino-theme .lotus-header-timezone-btn,\n.pre-dashboard.is-casino-theme .lotus-header-icon-btn,\n.dashboard-container.is-casino-theme .lotus-header-right,\n.dashboard-container.is-casino-theme .lotus-header-clock,\n.dashboard-container.is-casino-theme .lotus-header-clock-text,\n.dashboard-container.is-casino-theme .lotus-header-timezone-btn,\n.dashboard-container.is-casino-theme .lotus-header-icon-btn {\n  color: #ffffff !important;\n}\n\n.pre-dashboard.is-casino-theme .lotus-wallet-pill,\n.dashboard-container.is-casino-theme .lotus-wallet-pill {\n  background: rgba(255, 255, 255, 0.1) !important;\n  color: #ffffff !important;\n  height: 40px;\n  padding: 10px 12px;\n  border-radius: 8px;\n  margin-right: 8px;\n}\n\n.pre-dashboard.is-casino-theme .lotus-wallet-pill:hover,\n.pre-dashboard.is-casino-theme .lotus-wallet-pill.active,\n.dashboard-container.is-casino-theme .lotus-wallet-pill:hover,\n.dashboard-container.is-casino-theme .lotus-wallet-pill.active {\n  background: #2a2a2a !important;\n}\n\n.pre-dashboard.is-casino-theme .lotus-profile-pill,\n.dashboard-container.is-casino-theme .lotus-profile-pill {\n  background: #2c4f58 !important;\n  color: #ffffff !important;\n  height: 40px;\n  padding: 0 12px;\n  border-radius: 6px;\n}\n\n.pre-dashboard.is-casino-theme .lotus-profile-pill:hover,\n.pre-dashboard.is-casino-theme .lotus-profile-pill.active,\n.dashboard-container.is-casino-theme .lotus-profile-pill:hover,\n.dashboard-container.is-casino-theme .lotus-profile-pill.active {\n  background: #356069 !important;\n}\n\n.pre-dashboard.is-casino-theme .lotus-wallet-pill .icon,\n.pre-dashboard.is-casino-theme .lotus-profile-pill .icon,\n.dashboard-container.is-casino-theme .lotus-wallet-pill .icon,\n.dashboard-container.is-casino-theme .lotus-profile-pill .icon {\n  color: #ffffff !important;\n}\n\n/* Alias dashboard header to lotus header base styles */\n.dashboard-lotus-header-stack {\n  position: fixed !important;\n  top: 0;\n  left: 0;\n  right: 0;\n  z-index: 1000;\n  width: 100%;\n}\n\n.dashboard-lotus-header {\n  background: #0f2327;\n  width: 100%;\n  height: 60px;\n  position: relative !important;\n  top: auto;\n  left: auto;\n  right: auto;\n  z-index: auto;\n  font-family: \"Lato\", sans-serif !important;\n}\n\n@media (max-width: 768px) {\n  .dashboard-lotus-header {\n    position: relative !important;\n    height: 60px;\n  }\n}\n\n.dashboard-lotus-header-container {\n  width: 100%;\n  height: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: flex-start;\n  position: relative;\n}\n\n@media (max-width: 768px) {\n  .dashboard-lotus-header-container {\n    padding-right: 8px;\n    box-sizing: border-box;\n    overflow: visible;\n    min-width: 0;\n  }\n\n  .dashboard-lotus-mobile-hamburger {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    background: transparent;\n    border: none;\n    color: #fff;\n    cursor: pointer;\n    padding: 0;\n    margin-left: 15px;\n    width: 18px;\n    min-width: 18px;\n    height: 36px;\n    flex-shrink: 0;\n  }\n\n  .dashboard-lotus-mobile-hamburger.is-back {\n    width: 25px;\n    min-width: 25px;\n  }\n\n  .dashboard-lotus-mobile-hamburger .icon-burger {\n    font-size: 12px;\n    color: #fff;\n    line-height: 1;\n  }\n\n  .dashboard-lotus-mobile-hamburger .icon-angle-left {\n    font-size: 14px;\n    color: #fff;\n    line-height: 1;\n  }\n\n  .dashboard-lotus-header-left {\n    display: flex;\n    align-items: center;\n    height: 36px;\n    flex-shrink: 1;\n    min-width: 0;\n  }\n\n  .dashboard-lotus-logo {\n    height: 29px;\n    width: 120px;\n    max-width: 120px;\n    margin-left: 12px;\n    object-fit: contain;\n    flex-shrink: 1;\n  }\n}\n\n@media (max-width: 1023px) {\n  .lotus-casino-shell__banner {\n    height: auto;\n    min-height: 120px;\n  }\n}\n\n/* Mobile casino banners — Lotus 312×115 cover */\n@media (max-width: 1119px) {\n  .lotus-casino-shell__banner {\n    height: 115px;\n    min-height: 115px;\n    margin-bottom: 0;\n    overflow: hidden;\n  }\n\n  .lotus-casino-shell__banner .promo-banner-section {\n    height: 115px;\n    margin: 0;\n  }\n\n  .lotus-casino-shell__banner .promo-carousel-viewport {\n    height: 115px;\n  }\n\n  .lotus-casino-shell__banner .promo-slide {\n    height: 115px;\n    width: 312px;\n    max-width: calc(100% - 40px);\n    border-radius: 8px;\n    overflow: hidden;\n  }\n\n  .lotus-casino-shell__banner .promo-slide img {\n    width: 100%;\n    height: 115px;\n    object-fit: cover;\n    border-radius: 8px;\n  }\n\n  /*\n   * Casino mobile: document scroll so regulatory footer below content is reachable.\n   * (flex:1 + overflow-x:clip on layout wrapper otherwise traps scroll without footer)\n   */\n  .pre-dashboard.is-casino-theme,\n  .dashboard-container.is-casino-theme {\n    height: auto !important;\n    max-height: none !important;\n    overflow: visible !important;\n  }\n\n  .pre-dashboard.is-casino-theme .desktop-layout-wrapper.casino-layout,\n  .dashboard-container.is-casino-theme .desktop-layout-wrapper.casino-layout {\n    flex: none !important;\n    min-height: auto !important;\n    height: auto !important;\n    max-height: none !important;\n    overflow: visible !important;\n    overflow-x: visible !important;\n    overflow-y: visible !important;\n  }\n\n  .pre-dashboard.is-casino-theme .desktop-main-content.lotus-casino-main,\n  .dashboard-container.is-casino-theme .desktop-main-content.lotus-casino-main {\n    height: auto !important;\n    max-height: none !important;\n    min-height: auto !important;\n    overflow: visible !important;\n    overflow-x: visible !important;\n    overflow-y: visible !important;\n  }\n\n  .pre-dashboard.is-casino-theme > .lotus-regulatory-footer,\n  .dashboard-container.is-casino-theme > .lotus-regulatory-footer {\n    display: block !important;\n    background: #080808;\n    padding-bottom: 72px;\n    box-sizing: border-box;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
